import { Checkbox } from '@assembly-js/design-system';
import React from 'react';

interface HeaderCheckboxRendererProps {
  getBulkState: () => {
    isAllSelected: boolean;
    isIndeterminate: boolean;
    hasSelection: boolean;
  };
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

const CHECKBOX_CLASSES = { root: 'bulk-ds-checkbox' };

const HeaderCheckboxRenderer: React.FC<HeaderCheckboxRendererProps> = ({
  getBulkState,
  onSelectAll,
  onDeselectAll,
}) => {
  const { isAllSelected, isIndeterminate, hasSelection } = getBulkState();

  const handleChange = React.useCallback(() => {
    if (isAllSelected || isIndeterminate) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  }, [isAllSelected, isIndeterminate, onSelectAll, onDeselectAll]);

  return (
    <div
      className={`header-checkbox-wrapper${
        hasSelection ? ' header-checkbox-visible' : ''
      }`}
    >
      <Checkbox
        label=""
        checked={isAllSelected}
        indeterminate={isIndeterminate}
        onChange={handleChange}
        classes={CHECKBOX_CLASSES}
      />
    </div>
  );
};

export default HeaderCheckboxRenderer;
